import { ContractStageType } from "../../models/Entities/Contracts/ContractStageType";
import { CommonState } from "../common/state/commonState";


export interface ContractStageTypeState extends CommonState<ContractStageType> {}

export const ContractStageTypeUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // saving
    isSaving: false,
    isSavingSuccess: undefined,
    FailSaving: false,

    // adding
    isAdding: false,
    isAddingSuccess: undefined,
    FailAdding: false,
    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false,
    // AddRange
    isAddingFinishedSuccessfully: undefined,
    // updating
    isUpdating: false,
    isUpdatingSuccess: undefined,
    FailUpdating: false,
    // deleting
    isDeleting: false,
    isDeletingSuccess: undefined,
    FailDeleting: false,
    
}